
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/daftar-topik",
      function () {
        return require("private-next-pages/pelatihan-mandiri/daftar-topik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri/daftar-topik"])
      });
    }
  